import React, { useEffect } from "react";
import Menu from "../components/Menu";
import Login from "../components/Login";
import { setTitle } from "../helpers/title";

export default function LoginPage() {
  useEffect(() => {
    setTitle("Login");
  }, []);

  return (
    <div>
      <div className="container"></div>
      <div className="content">
        <Login />
      </div>
      <Menu />
    </div>
  );
}
